import React from "react";
import { FaEye, FaBullseye, FaCheckCircle } from "react-icons/fa";

const AboutSection = () => {
  return (
    <section class="py-20 bg-gray-50">
      <div class="container mx-auto px-4">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div class="space-y-6">
            <div class="relative">
              <img
                src="./img/service/aboutus.png"
                alt="aboutimg"
                class="w-full rounded-lg shadow-lg"
              />
            </div>
          </div>

          <div>
            <h2 class="text-4xl font-bold mb-4 text-gray-800">
              <span class="text-orange-600">About Us</span>
            </h2>
            <div class="w-16 h-1 bg-orange-600 mb-6"></div>

            <h3 class="text-2xl font-semibold mb-4 text-gray-800">
              <br />
              <span class="text-orange-600">
                Welcome to STRATUS INSTRUMENTATION PVT. LTD.
              </span>
            </h3>
            <p class="text-gray-600 mb-6 leading-relaxed">
              <p class="text-gray-600 mb-6 leading-relaxed">
                <span class="text-lg font-semibold text-orange-600 mb-2">
                  STRATUS INSTRUMENTATION PVT. LTD.
                </span>{" "}
                has been a long-term trusted partner for clients in the Navi
                Mumbai & all over National International region; working closely
                with our clients allows us to act in their best interest over
                the long term.
              </p>
              <p class="text-gray-600 mb-6 leading-relaxed">
                <span class="text-lg font-semibold text-orange-600 mb-2">
                  STRATUS INSTRUMENTATION PVT. LTD.
                </span>{" "}
                is a Service Company in which Do Instruments Calibration and
                temperature mapping located in Kamothe (Panvel), Navi Mumbai,
                servicing clients nationwide.
              </p>
              <p class="text-gray-600 mb-6 leading-relaxed">
                <span class="text-lg font-semibold text-orange-600 mb-2">
                  STRATUS INSTRUMENTATION PVT. LTD.
                </span>{" "}
                is the leading provider of business & calibration related
                solutions in the Navi Mumbai.
              </p>
              <p class="text-gray-600 mb-6 leading-relaxed">
                Our dedicated staffs have a combined experience.
              </p>
              We are extremely committed to delivering quality advice, sales and
              support to assist our clients to achieve the maximum from their
              instrumentation investments.
            </p>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 mt-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          {/* Our Vision */}
          <div
            className="flex flex-col p-8 border-b-4 border-orange-500 bg-white rounded-lg shadow-md 
                transition-transform duration-300 transform hover:-translate-y-2 hover:shadow-xl"
          >
            <div className="flex items-center justify-center mb-4">
              <FaEye className="text-4xl text-orange-600" />
            </div>
            <h4 className="text-3xl font-bold text-orange-600 mb-4 text-center">
              Our Vision
            </h4>
            <p className="text-gray-700 leading-relaxed flex-grow text-justify mt-5">
              To be India’s most trusted and innovative partner in calibration,
              validation, and instrumentation solutions—delivering precision,
              reliability, and excellence that empower industries to achieve
              global quality standards.
            </p>
          </div>

          {/* Our Mission */}
          <div
            className="flex flex-col p-8 border-b-4 border-orange-500 bg-white rounded-lg shadow-md 
                transition-transform duration-300 transform hover:-translate-y-2 hover:shadow-xl"
          >
            <div className="flex items-center justify-center mb-4">
              <FaBullseye className="text-4xl text-orange-600" />
            </div>
            <h4 className="text-3xl font-bold text-orange-600 mb-4 text-center">
              Our Mission
            </h4>
            <ul className="space-y-4 text-gray-700 text-base flex-grow">
              {[
                "To provide accurate, timely, and NABL-compliant calibration and validation services.",
                "To maintain the highest level of technical expertise, ethical practices, and customer satisfaction.",
                "To continuously innovate and adopt cutting-edge technologies for better service delivery.",
                "To build long-term relationships through quality, transparency, and commitment.",
              ].map((mission, index) => (
                <li key={index} className="flex items-start gap-3">
                  <FaCheckCircle className="text-orange-500 mt-1 shrink-0" />
                  {mission}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
